<template>
  <div id="agree">
    <el-button size="medium" @click="exportPDF" type="danger" class="export"
      >导出</el-button
    >
    <div class="topic-title">自由职业者服务协议</div>
    <div class="clause-content">甲方：{{channel_name}}</div>
    <div class="clause-content margin">统一社会信用代码：{{channel_taxpayer}}</div>
    <div class="clause-content">乙方：{{fullname}}</div>
    <div class="clause-content">身份证号：{{id_number}}</div>
    <div class="tips-clause">提示条款: </div>
    <div class="tips tips-key">【审慎阅读】为维护双方的合法权益，在点击同意或书面签署《自由职业者服务协议》（下称“本协议”）之前，并认真阅读本协议文本，充分理解各条款内容，特别是权利义务条款、法律适用和管辖条款。上述条款以粗体及下划线标识，双方应重点阅读。
    </div>
    <div class="tips tips-key">
      【签约】甲乙双方应当按照本协议的约定填写相应的主体/个人信息、阅读并同意本协议且完成全部申请或书面签署后，或你通过网络页面点击同意或以其他任何形式确认本协议的，即表示双方均已充分阅读、理解并接受本协议的全部内容，并达成一致意见，此后任何一方均不得以未阅读/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果任何一方不同意本协议或其中任何条款约定，请立即停止任何的电子或书面签署程序。
    </div>
    <div class="tips tips-key">
      【非格式条款】甲乙双方确认，本协议条款是经当事人充分沟通协商，达成合意后拟定的。
    </div>
    <div class="tips tips-key">
      【服务关系】甲乙双方通过本协议建立服务关系，甲方是服务提供方，乙方是服务接受方，适用《民法典》和其他民事法律。
    </div>
    <div class="tips tips-key">
      特别提示：
    </div>
    <div class="tips tips-key">
      军人、公职人员等国家法律法规和纪律规定禁止从事兼职或者经商的人员，严禁使用本协议项下甲方提供的服务。
    </div>
    <div class="tips tips-key">
      禁止任何人使用甲方提供的服务从事违反法律及行政法规等行为，如传销、诈骗、洗钱、受贿、偷税、漏税及其他甲方认为不适用于本协议服务内容的行为，一经发现的，甲方有权立即上报国家机关部门并依据相关法律规定追究责任主体的法律责任。
    </div>
    <div class="clause">
      <div class="clause-title">第一条 服务工作内容</div>
      <div class="clause-content">
        1.1 鉴于乙方与乙方的服务对象【 {{company_name}} 】公司存在合作关系，故【 {{company_name}} 】公司委托甲方为乙方提供【 {{category_name}} 】等服务。
      </div>
      <div class="clause-content">1.2 乙方承诺和保证，乙方从事的生产经营活动不违反任何法律法规和政策规定；如乙方需要其他服务或法律法规规定的服务等资质，应由乙方自行负责办理全部事宜；若因乙方自身原因未办理前述事宜，则乙方应承担由此引起的全部法律后果，并赔偿由此给甲方造成的全部经济损失。</div>
      <div class="clause-content">
        1.3 甲方在收到【 {{company_name}} 】公司支付的总服务费后，根据【 {{company_name}} 】公司的指令和要求向乙方进行佣金结算。
      </div>
    <div class="clause-content">
      1.4 本协议各方在此明确约定:
    </div>
    <div class="clause-content">
      1.4.1 甲方与【 A 】公司不构成任何形式的劳务派遣关系:
    </div>
    <div class="clause-content">
      1.4.2 甲、乙双方不构成任何劳动法律层面的雇佣、劳动、劳务关系，乙方不享有与甲方的任何基于劳动和雇佣关系产生的权利;
    </div>
    <div class="clause-content">
      1.5 乙方在甲方平台登记从事临时生产经营(含已办理临时税务登记的自然人或工商注册的经营主体)，乙方独立经营并独立承担经营风险。
    </div>
    </div>
    <div class="clause">
      <div class="clause-title">第二条 协议效力</div>
      <div class="clause-content key tips-key">2.1 乙方的签约信息（包括乙方的姓名、身份证号等信息），以乙方提供的信息为准（包括但不限于线上提供或线下提供）。乙方承诺并保证乙方所提供的签约信息真实、准确，以免影响乙方和甲方之间的《自由职业者服务协议》效力。本协议条款若为电子签约方式，自乙方线上确认签署之日起生效；若为书面签署，自双方签署本协议之日起生效。
      </div>
      <div class="clause-content">2.2 本协议自签订之日起一年内有效。期限届满，双方应另行签署新的协议；若双方未签署新的协议，甲方继续按照本协议约定向乙方提供约定的服务，且乙方未提出书面异议的，视为双方同意协议期限顺延直至按照本协议约定终止或解除时为止。</div>
      <div class="clause-content key tips-key">2.3 本协议在发生下列情形时自然终止：</div>
      <div class="clause-content-content key tips-key">a. 甲方和【 {{company_name}} 】公司终止/解除合作的；
      </div>
      <div class="clause-content-content key tips-key">b. <text>【 {{company_name}} 】</text>公司未按照【 {{company_name}} 】与甲方签订的《共享经济综合服务合同》的约定，按时支付总服务费的；</div>
      <div class="clause-content-content key tips-key">c. <text>【 {{company_name}} 】</text>公司未向甲方支付乙方的相关费用的；</div>
      <div class="clause-content-content key tips-key">d. <text>【 {{company_name}} 】</text>公司与乙方的合作产生纠纷的；</div>
      <div class="clause-content-content key tips-key">e. 乙方与本协议相关的行为违反法律法规、政策规定的；</div>
      <div class="clause-content-content key tips-key">f. 因不可抗力原因导致本协议不能继续履行的。</div>
    </div>
    <div class="clause">
      <div class="clause-title">第三条 甲方的权利与义务</div>
      <div class="clause-content third">3.1 甲方有权为提供本协议约定的服务而获取乙方的相关信息（包括但不限于个人身份信息、实名登记手机号码、银行账户相关信息等），并将乙方的相关信息提交第三方机构进行身份验证。若乙方提供任何错误、虚假、失效或不完整的资料，或者甲方有合理理由怀疑资料为错误、虚假、过期或不完整，有权暂停或终止向乙方提供服务且不承担任何责任；乙方承诺并同意承担因此所产生的所有损失，包括但不限于直接损失、间接损失。若因国家法律法规、部门规章或监管机构的要求，甲方或甲方应【 {{company_name}} 】公司要求需要乙方补充提供任何相关资料时，如乙方不能及时配合提供，甲方有权暂停或终止向乙方提供部分或全部服务。</div>
      <div class="clause-content">3.2 甲方收到【 {{company_name}} 】公司支付的费用及支付指令后，应及时向乙方提供相应服务，对此服务甲方不再向乙方收取其他任何费用。</div>
    </div>
    <div class="clause">
      <div class="clause-title">第四条 乙方的权利与义务</div>
      <div class="clause-content">4.1 乙方与【 {{company_name}} 】公司的合作内容不得有侵犯他人知识产权、财产权、人身权、肖像权、隐私权、商业秘密或其他合法权益以及其他违反国家法律法规、国家政策或有悖于公序良俗的内容；否则，因此导致甲方遭受损失的（包括但不限于行政处罚、民事责任、刑事责任），均由乙方承担全部赔偿责任，同时甲方有权单方解除本协议。
      </div>
      <div class="clause-content key">4.2 协议期内，乙方应在甲方以及【 {{company_name}} 】公司许可范围内使用本协议有关的商业信息；协议期内以及协议终止后，乙方均有义务对双方合作的有关协议及合作过程中知悉的甲方、【 {{company_name}} 】公司的相关信息予以保密，未经书面许可，乙方不得以任何方式向其它方披露、给予或转让该等保密信息；否则，因此导致甲方及/或【 {{company_name}} 】公司或其关联公司的损失，由乙方负责赔偿。
      </div>
    </div>
    <div class="clause">
      <div class="clause-title">第五条 服务费用的支付</div>
      <div class="clause-content key tips-key">5.1【 {{company_name}} 】公司根据与甲方签署的《共享经济综合服务协议》的约定向甲方支付总服务费，包括乙方佣金及佣金服务费（自由职业者应缴纳的税费及甲方的服务费用之和，税费按照有关税收政策规定及甲方主管税务机关的要求为准）。
      </div>
      <div class="clause-content key tips-key">5.2乙方应自行负担就其取得的佣金需缴纳的行政收费（如有）。</div>
      <div class="clause-content">5.3 因乙方提供的收款帐户不实造成的一切损失由乙方自行承担。</div>
    </div>
    <div class="clause">
      <div class="clause-title six">第六条 违约责任</div>
      <div class="clause-content">6.1 双方应按本协议约定履行，如有违反，守约方有权要求对方及时改正；造成对方损失的，守约方有权要求违约方赔偿。</div>
      <div class="clause-content">6.2 因不可抗力造成损失的，彼此不负赔偿责任，但发生不可抗力一方应及时将有关情况通知另一方，并尽最大努力进行补救。本协议所称不可抗力是指不能预见、不能克服并不能避免且对一方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、火灾和风暴等以及社会事件如战争、动乱、政府行为、黑客事件、大范围电信事故等。
      </div>
    </div>
    <div class="clause">
      <div class="clause-title">第七条 涉税事务委托授权</div>
      <div class="clause-content key tips-key">7.1乙方委托甲方代理本协议的相关内容。甲方为【 {{company_name}} 】公司支付乙方自由职业者经营活动所得提供结算服务时，有权按照有关税收政策规定及甲方主管税务机关的要求，代理申报缴纳前述乙方经营所得佣金应缴税费，该等款项将从【 {{company_name}} 】公司所支付的服务费中予以扣减。应甲方要求，乙方应提供与税款申报缴纳相关的协助及信息。</div>
      <div class="clause-content key tips-key">7.2按照有关税收政策规定及甲方主管税务机关的要求，乙方授权委托甲方事项如下：</div>
    <div class="clause-content key tips-key">7.2.1 代理乙方办理涉税登记;</div>
    <div class="clause-content key tips-key">7.2.2 代理已办理涉税登记的乙方办理申请代开发票、申请领用发票等发票事项，提供便利化发票服务。</div>
    <div class="clause-content key tips-key">7.2.3代理申报缴纳前述乙方经营所得佣金应缴税费:甲方向企业客户收取经营服务费并将扣除税费之后的金额转付给乙方。</div>
    <div class="clause-content key tips-key">7.3乙方确认甲方根据本协议授权提交的相关申报资料和信息是真实、完整、准确，和符合有关法律法规的。</div>
    
    </div>
    <div class="clause">
      <div class="clause-title">第八条 争议解决</div>
      <div class="clause-content key tips-key">8.1 本协议的订立、执行和解释及争议的解决均应适用中国法律。凡因本协议引起的或与本协议有关的任何争议，双方应友好协商解决。如不能协商解决，双方均同意提请杭州仲裁委员会解决。双方同意以在平台存管的相关电子证据作为仲裁庭认定事实的依据，并认可平台就证据存管出具的相关证明文件。仲裁裁决是终局的，对双方均有约束力。双方清楚了解本条款的含义，并对此无异议。
      </div>
    </div>
    <div class="clause">
      <div class="clause-content">（以下无正文）</div>
      <div class="both-sides">
        <div class="party-a">
          <img crossorigin="anonymous" v-if="seal_url" class="zhangImg" :src="seal_url" />
          <div>
            甲方：（盖章）
			<!-- <span>{{ this.channel_name }}</span> -->
          </div>
          <div>
            签署日期：<span>{{ this.created_at }}</span>
          </div>
        </div>
        <div class="party-b">
          <div class="bb-wrapper">
            <div>乙方：</div>
			
            <img
              id="autograph"
              :src="this.sign_url"
              v-if="this.sign_url"
              :data-imgUrl="this.sign_url"
            />
            <!-- {{ this.sign_url ? "" : this.fullname }} -->
			（签字捺印或点击同意）
          </div>
          <div>
            <!-- 身份证号码：<span>{{ this.id_number }}</span> -->
          </div>
          <div>
            签署日期：<span>{{ this.created_at }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
export default {
  name: "ExportPdf",
  data() {
    return {
      agreeList: [
        {
          content: `【审慎阅读】为维护双方的合法权益，在点击同意或书面签署《自由职业者服务协议》（下称“本协议”）之前，双方应认真阅读本协议文本，充分理解各条款内容，特别是权利义务条款、法律适用和管辖条款。上述条款以粗体及下划线标识，双方应重点阅读。`,
        },
        {
          content: `【签约】甲乙双方应当按照本协议的约定填写相应的主体/个人信息、阅读并同意本协议且完成全部申请或书面签署后，即表示双方均已充分阅读、理解并接受本协议的全部内容，并达成一致意见，此后任何一方均不得以未阅读/不理解本协议内容或类似言辞做任何形式的抗辩。阅读本协议的过程中，如果任何一方不同意本协议或其中任何条款约定，请立即停止任何的电子或书面签署程序。`,
        },
        {
          content: `【非格式条款】甲乙双方确认，本协议条款是经当事人充分沟通协商，达成合意后拟定的。`,
        },
		{
          content: `【服务关系】甲乙双方通过本协议建立服务关系，甲方是服务提供方，乙方是服务接受方，适用《民法典》和其他民事法律。`,
		}
      ],
      category_name: "",
      channel_name: "",
      company_name: "",
      created_at: "",
      sign_url: "",
      fullname: "",
      id_number: "",
      channel_taxpayer:"",
      setId:'',
      id:'',
      seal_url:''
    };
  },
  created() {
   this.getsignInfoById()
    //设置跳转后滚动条默认为0
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.category_name = this.$route.query.category_name;
    this.channel_name = this.$route.query.channel_name;
    this.company_name = this.$route.query.company_name;
    this.created_at = this.$route.query.created_at.split(" ")[0];
    // this.sign_url = `https://xl-online.oss-cn-hangzhou.aliyuncs.com/xlh5/customer/1595236416626.2603.png`
    this.sign_url = this.$route.query.sign_url;
    this.id_number = this.$route.query.id_number;
    this.fullname = this.$route.query.fullname;
	this.channel_taxpayer = this.$route.query.channel_taxpayer;
	const settlement_id = localStorage.getItem('settlementId')?localStorage.getItem('settlementId'):''
	let setId = settlement_id.replace(/"/g,'')
	this.setId = setId.toString()
  },
  methods: {
    //获取支持批量人才状态
    async getsignInfoById() {
      let args = {
        id: this.$route.query.id,
      };
      let data = await this.$api.getsignInfoById(args);
      if (data && data.status===1) {
        this.seal_url = data.seal_url;
      }
    },
    exportPDF() {
      const title = "自由职业者协议";
      this.getPdf(title);
    },
    getPdf(title) {
      const opts = {
        scale: 2,
        dpi: window.devicePixelRatio * 4,
        useCORS: true,
        allowTaint: true, //允许加载跨域的图片
        tainttest: true, //检测每张图片都已经加载完成
        logging: false, //日志开关，发布的时候记得改成false
      };
      var canvas = document.createElement("canvas"),
        // url = `https://xl-online.oss-cn-hangzhou.aliyuncs.com/xlh5/customer/1595236416626.2603.png`,
        url = this.sign_url,
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous"; // 重点！设置image对象可跨域请求
      img.src = url + "?timeStamp=" + new Date().getTime(); //解决缓存引起访问失败需要添加时间戳。。。。。问题的关键点
      if (url) {
        img.onload = function () {
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          // 将canvas的透明背景设置成白色
          var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          for (var i = 0; i < imageData.data.length; i += 4) {
            // 当该像素是透明的，则设置成白色
            if (imageData.data[i + 3] == 0) {
              imageData.data[i] = 255;
              imageData.data[i + 1] = 255;
              imageData.data[i + 2] = 255;
              imageData.data[i + 3] = 255;
            }
          }
          ctx.putImageData(imageData, 0, 0);
          var dataURL = canvas.toDataURL("image/jpeg");
          document.getElementById("autograph").setAttribute("src", dataURL);
          html2Canvas(document.getElementById("agree"), opts).then(function (
            canvas
          ) {
            console.log(canvas, "canvasa");
            let contentWidth = canvas.width;
            let contentHeight = canvas.height;
            let pageHeight = (contentWidth / 592.28) * 841.89;
            let leftHeight = contentHeight;
            let position = 0;
            let imgWidth = 595.28;
            let imgHeight = (592.28 / contentWidth) * contentHeight;
            let pageData = canvas.toDataURL("image/jpeg", 1.0);
            let PDF = new JsPDF("", "pt", "a4");
            if (leftHeight < pageHeight) {
              PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
            } else {
              while (leftHeight > 0) {
                PDF.addImage(
                  pageData,
                  "JPEG",
                  0,
                  position,
                  imgWidth,
                  imgHeight
                );
                leftHeight -= pageHeight;
                position -= 841.89;
                if (leftHeight > 0) {
                  PDF.addPage();
                }
              }
            }
            // var blob = PDF.output("blob");
            // window.open(URL.createObjectURL(blob));
            PDF.save(title + ".pdf");
          });
        };
      } else {
        html2Canvas(document.getElementById("agree"), opts).then(function (
          canvas
        ) {
          console.log(canvas, "canvasb");
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          // var blob = PDF.output("blob");
          // window.open(URL.createObjectURL(blob));
          PDF.save(title + ".pdf");
        });
      }
    },
  },
};
</script>
<style scoped lang="stylus">
.margin{
	margin-bottom: 10px;
}
.export {
  position: absolute;
  top: 20px;
  right: 40px;
}

#agree {
  color: #000;
  width: 596px;
  margin: 0 auto;
  padding: 0 60px;
  background: #fff;
}

.topic-title {
  display: block;
  text-align: center;
  padding: 20px 0;
  font-weight: bolder;
  font-size: 18pt;
}

.tips-clause {
  padding: 10px 0;
  font-weight: bolder;
  font-size: 9pt;
  text-indent: 2em;
}

.tips {
  // padding: 10px 0
  font-size: 9pt;
  font-weight: bolder;
  line-height: 20px;
  text-indent: 2em;
}

.tips-key {
  text-decoration: underline;
}

.terms {
  // padding-top: 20px
  // padding-bottom: 10px
  font-size: 9pt;
  line-height: 20px;
  text-indent: 2em;
}

.clause {
  padding: 10px 0;
}

.clause-title {
  margin-top: 15px;
  font-weight: bolder;
  font-size: 9pt;
  color: #000;
  text-indent: 2em;
}

.clause-content, .clause-content-content {
  // padding: 10px 0
  font-size: 9pt;
  line-height: 20px;
  text-indent: 2em;
}

.clause-content-content {
  margin-left: 20px;
}

.enclosure {
  text-align: center;
  font-weight: bolder;
  margin: 50px 0;
  font-size: 9pt;
}

.sign-company {
  margin-top: 30px;
  padding: 20px 0;
}

.key {
  font-weight: bolder;
  text-decoration: underline;
}

.close {
  margin-bottom: 30px;
}

.btn-row {
  margin-top: 10px;
  padding: 0 10px;
}

.both-sides {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 9pt;
  margin-top: 55px;
}

.party-a {
  line-height: 100px;
  margin-top: -35px;
  width: 100%;
  text-indent: 2em;
  position:relative;
}

.zhangImg{
	position:absolute;
	left:0px;
	top:0px;
	width:140px;
}

.party-b {
  line-height: 100px;
  margin-top: -35px;
  width: 100%;
}

.bb-wrapper {
  display: flex;
  flex-direction: row;
  position: relative;
}

#autograph {
  width: 100px;
  height: 75px;
  position: absolute;
  top: 62px;
  left:40px;
}

.third {
  margin-top: 200px;
}

.six {
  margin-top: 200px;
}
</style>


